<template>
<div v-if="show">
    <div class="nodata_chart" :style="{color:'rgba(0, 0, 0, 0.45)', background:'#fbfbfb', height:`${height}px`, lineHeight:`${height}px`, textAlign:'center'}"  v-if="datas.length<=0">
        暂无数据
    </div>
    <v-chart :id="`chart${uuid}`" :force-fit="true" :height="height" :data="datas" :padding='[0, 0, 0, 20]' :scale="chart.scale"> 
      <v-facet type="rect" :fields="['stage']" :padding="50" :showTitle="false" :eachView="eachView" />
    </v-chart>
</div>
</template>

<script>
import moment from "moment"

import Vue from 'vue'
import Viser from 'viser-vue'
import { registerShape, Global } from 'viser-vue';
import {initType, initScale, initAxis, initData, initTooltip, DefaultTheme} from '@/utils/chart'
Vue.use(Viser)

const eachView = function (view, facet) {
  var data = facet.data;
  data.push({'stage':'其他', 'whole_ratio':100-data[0].whole_ratio})

  view.source(data);
  view.coord('theta', {
    radius: 0.9,
    innerRadius: 0.7
  });
  view.intervalStack().position('whole_ratio').color('stage', ['#1890FF', '#eceef1']).opacity(1);
  view.guide().html({
    position: ['50%', '50%'],
    html: `<div class="udidconversion_guide conversion_inner">
        <p style="font-weight:bold">${data[0].cnt}台设备</p>
        <p>${data[0].whole_ratio}%留存</p>
      </div>`
  });
  view.guide().html({
    position: ['50%', '0'],
    html: `<div class="udidconversion_guide conversion_name">${data[0].stage}</div>`
  });
  if(data[0].order!=1) {
    view.guide().html({
      position: ['0%', '50%'],
      html: `<div class="udidconversion_guide conversion_stage">
          <p>${data[0].stage_ratio}%</p>
          <div class="guide_arrow"><div class="guide_block"></div><div class="guide_triangle"></div></div>
        </div>`
    });
  }
}

export default {
    props:{
        datas: {type:Array, default:()=>[]},
        height: {type:Number, default:500},
    },
    watch: {
      datas() {
        this.show = false
        this.$nextTick(()=>{
          this.show = true
        })
      }
    },
    computed: {
      chart() {
          return {
              scale: [],
          }
      },
    },
    mounted() {
        this.uuid = this.guid()
    },
    data() {
        return {
            uuid:"",
            show: true,
            eachView,
        }
    },
    methods: {
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            })
        },
        format(value) {
          if(!value) {
            return '-'
          }
          if(!isNaN(value))
              return Math.round(value).toLocaleString()
          else
              return value
        },
        mouse() {
        }
    }
}
</script>
<style lang="less">
@import '../../../assets/less/var.less';
.udidconversion_guide {
  &.conversion_name {
    font-size:13px; 
    text-align: center;
    font-weight: bold;
  }
  &.conversion_inner {
    p {
      font-size:13px; 
      text-align: center;
      margin:0;
      line-height: 18px;
    }
  }
  &.conversion_stage {
    width: 66px;
    margin: -20px 0 0 -50px;
    p {
      font-size:13px; 
      text-align: center;
    }
    .guide_arrow {
      .guide_block {
        height:10px; 
        width:50px;
        margin:5px 0 5px 0; 
        background:#eceef1; 
        float:left;
      }
      .guide_triangle {
        float:right; width: 0; height: 0;
        border-top: 10px solid transparent;
        border-left: 16px solid #eceef1;
        border-bottom: 10px solid transparent;
      }
    }
  }
}
.vip_axis_guide {
  width:50px;
  font-size:13px;
  text-align: right;
  font-weight: bold;
}
.vip_left_guide {
  width: 200px;
  margin:0 0 0 120px;
  color: #1890ff;
  font-size:13px;
  span {
    width:100px;
    text-align: right;
    display: inline-block;
  }
}
.vip_right_guide {
  width: 200px;
  margin:0 0 0 -100px;
  color: #7acb7a;
  font-size:13px;
  span {
    width:100px;
    text-align: right;
    display: inline-block;
  }
}
.vip_guide_title {
  margin-top:-40px;
}
.vip_chart_legend {
  position:relative;
  z-index:99999;
  text-align: center;
  margin:-20px 0 0 110px;
  .vip_chart_legend_item {
    display: inline-block;
    cursor:default;
    margin:0 10px;
    span {
      display: inline-block;
      height:10px;
      width:10px;
      margin:0 10px 0 0;
    }

    &.hide {
      color:#888;
      span {
        background: #888;
      }
    }
  }
}
</style>
